import { useEffect } from 'react'
import { startWorkspaceTelemetry } from './workspaceTelemetry'

/** Mount once per workspace. Starts the recorder for the challenge and stops it on unmount/change. */
export function useWorkspaceTelemetry(challengeId: string | undefined): void {
  useEffect(() => {
    if (challengeId === undefined || challengeId === '') return
    return startWorkspaceTelemetry(challengeId)
  }, [challengeId])
}
